// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca63c93a","239":"b3f3ae97","732":"14611c1f","762":"9dac557d"}[chunkId] + ".chunk.js";
};